<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>APPELS D'OFFRES</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>APPELS D'OFFRES</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!--section class="requests-hero-section">
    <div class="container">
        <div class="hero-content text-center">
            <div class="hero-icon">
                <i class="icofont-folder"></i>
            </div>
            <h1 class="hero-title">Découvrez les Opportunités d'Affaires</h1>
            <p class="hero-subtitle">Explorez notre catalogue d'appels d'offres et trouvez les opportunités qui correspondent à votre expertise</p>
        </div>
    </div>
</section-->

<section class="requests-stats-section">
    <div class="container">
        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-icon">
                    <i class="icofont-folder"></i>
                </div>
                <div class="stat-content">
                    <h3 class="stat-number" attr.data-count="{{ requests?.length || 0 }}">0</h3>
                    <p class="stat-label">Appels d'Offres</p>
                </div>
            </div>
            
            <div class="stat-card">
                <div class="stat-icon">
                    <i class="icofont-calendar"></i>
                </div>
                <div class="stat-content">
                    <h3 class="stat-number" attr.data-count="{{ activeRequests?.length || 0 }}">0</h3>
                    <p class="stat-label">En Cours</p>
                </div>
            </div>
            
            <div class="stat-card">
                <div class="stat-icon">
                    <i class="icofont-clock-time"></i>
                </div>
                <div class="stat-content">
                    <h3 class="stat-number" attr.data-count="{{ urgentRequests?.length || 0 }}">0</h3>
                    <p class="stat-label">Urgents</p>
                </div>
            </div>
            
            <div class="stat-card">
                <div class="stat-icon">
                    <i class="icofont-check-circled"></i>
                </div>
                <div class="stat-content">
                    <h3 class="stat-number" attr.data-count="{{ completedRequests?.length || 0 }}">0</h3>
                    <p class="stat-label">Terminés</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="requests-filter-section">
    <div class="container">
        <div class="filter-card">
            <div class="filter-header">
                <h3 class="filter-title">
                    <i class="flaticon-search"></i>
                    Recherche Avancée
                </h3>
                <button class="filter-toggle" (click)="toggleAdvancedFilters()">
                    <i class="icofont-settings"></i>
                    Filtres Avancés
                </button>
            </div>
            
            <div class="search-container">
                <div class="search-input-wrapper">
                    <i class="flaticon-search search-icon"></i>
                    <input 
                        type="text" 
                        class="form-control search-input" 
                        [(ngModel)]="search" 
                        placeholder="Saisir le nom d'un appel d'offre..." 
                        name="search" 
                        autocomplete="off"
                        (input)="onSearchInput()"
                    >
                    <button class="search-btn" type="button">
                        <i class="icofont-search"></i>
                    </button>
                </div>
            </div>
            
            <div class="advanced-filters" [class.expanded]="showAdvancedFilters">
                <div class="filters-grid">
                    <div class="filter-group">
                        <label class="filter-label">
                            <i class="flaticon-calendar"></i>
                            Statut
                        </label>
                        <select class="form-select" [(ngModel)]="statusFilter" (change)="applyFilters()">
                            <option value="">Tous les statuts</option>
                            <option value="published">En cours</option>
                            <option value="expired">Expiré</option>
                            <option value="aborded">Annulé</option>
                        </select>
                    </div>
                    
                    <div class="filter-group">
                        <label class="filter-label">
                            <i class="flaticon-clock"></i>
                            Urgence
                        </label>
                        <select class="form-select" [(ngModel)]="urgencyFilter" (change)="applyFilters()">
                            <option value="">Tous</option>
                            <option value="urgent">Urgent (≤ 7 jours)</option>
                            <option value="normal">Normal (> 7 jours)</option>
                        </select>
                    </div>
                    
                    <div class="filter-group">
                        <label class="filter-label">
                            <i class="flaticon-calendar"></i>
                            Date de publication
                        </label>
                        <select class="form-select" [(ngModel)]="dateFilter" (change)="applyFilters()">
                            <option value="">Toutes les dates</option>
                            <option value="today">Aujourd'hui</option>
                            <option value="week">Cette semaine</option>
                            <option value="month">Ce mois</option>
                        </select>
                    </div>
                </div>
                
                <div class="filter-actions">
                    <button class="btn btn-secondary" (click)="clearFilters()">
                        <i class="flaticon-refresh"></i>
                        Réinitialiser
                    </button>
                    <button class="btn btn-primary" (click)="applyFilters()">
                        <i class="flaticon-check"></i>
                        Appliquer
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="requests-content-section">
    <div class="container">
        <div class="row">
            <!-- Sidebar Catégories -->
            <div class="col-lg-4">
                <div class="categories-sidebar">
                    <div class="sidebar-header">
                        <h3 class="sidebar-title text-white">
                            <i class="icofont-folder"></i>
                            SECTEURS D'ACTIVITÉ
                        </h3>
                        <p class="sidebar-subtitle">Filtrez par domaine d'expertise</p>
                    </div>
                    
                    <div class="categories-list">
                        <ng-container *ngIf="!categoryService.value">
                            <div class="category-skeleton" *ngFor="let item of [].constructor(10); let i = index">
                                <div class="skeleton-item"></div>
                            </div>
                        </ng-container>
                        
                        <ng-container *ngIf="categoryService.value">
                            <div 
                                class="category-item" 
                                *ngFor="let category of categoryService.value"
                                [class.active]="selectedCategory === category.slug"
                                (click)="onClick(category.slug)"
                            >
                                <div class="category-icon">
                                    <i class="icofont-duplicate"></i>
                                </div>
                                <div class="category-content">
                                    <h4 class="category-name">{{ category.name }}</h4>
                                    <span class="category-count">{{ category.number_of_requests }} offres</span>
                                </div>
                                <div class="category-arrow">
                                    <i class="icofont-arrow-right"></i>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            
            <!-- Contenu Principal -->
            <div class="col-lg-8">
                <div class="content-header">
                    <div class="results-info">
                        <h3 class="results-title">
                            <i class="icofont-list"></i>
                            Résultats de la recherche
                        </h3>
                        <p class="results-count">
                            {{ filteredRequests?.length || requests?.length }} appel(s) d'offre trouvé(s)
                        </p>
                    </div>
                    
                    <div class="view-options">
                        <button class="view-btn active" (click)="setViewMode('grid')" [class.active]="viewMode === 'grid'">
                            <i class="icofont-grid-advance"></i>
                        </button>
                        <button class="view-btn" (click)="setViewMode('list')" [class.active]="viewMode === 'list'">
                            <i class="icofont-list"></i>
                        </button>
                    </div>
                </div>
                
                <!-- Loading Skeleton -->
                <div class="loading-skeleton" *ngIf="loading">
                    <div class="skeleton-card" *ngFor="let item of [].constructor(5); let i = index">
                        <div class="skeleton-header">
                            <div class="skeleton-avatar"></div>
                            <div class="skeleton-title"></div>
                        </div>
                        <div class="skeleton-content">
                            <div class="skeleton-line"></div>
                            <div class="skeleton-line"></div>
                            <div class="skeleton-line"></div>
                        </div>
                    </div>
                </div>
                
                <!-- Liste des Appels d'Offres -->
                <ng-container *ngIf="requests && !loading">
                    <div class="requests-container" [class.grid-view]="viewMode === 'grid'">
                        <div 
                            class="request-card" 
                            *ngFor="let request of filteredRequests; let i = index"
                            
                        >
                            <div class="card-header">
                                <div class="company-info">
                                    <div class="company-logo">
                                        <img [ngSrc]="request.buyer.logo" width="60" height="60" [alt]="request.buyer.name">
                                    </div>
                                    <div class="company-details">
                                        <h4 class="company-name">{{ request.buyer.name }}</h4>
                                        <span class="company-type">Acheteur</span>
                                    </div>
                                </div>
                                
                                <div class="request-status">
                                    <span class="status-badge" [ngClass]="getStatusClass(request.status)">
                                        <i [class]="getStatusIcon(request.status)"></i>
                                        {{ getStatusText(request.status) }}
                                    </span>
                                </div>
                            </div>
                            
                            <div class="card-body">
                                <h3 class="request-title">{{ request.name }}</h3>
                                
                                <div class="request-meta">
                                    <div class="meta-item">
                                        <i class="flaticon-calendar"></i>
                                        <span>Publié le {{ request.published_at | date:'d MMMM yyyy' }}</span>
                                    </div>
                                    
                                    <div class="meta-item">
                                        <i class="flaticon-clock"></i>
                                        <span>Expire le {{ request.expired_at | date:'d MMMM yyyy' }}</span>
                                    </div>
                                    
                                    <div class="meta-item" *ngIf="request.jour_restant">
                                        <i class="flaticon-time"></i>
                                        <span>{{ request.jour_restant }} jours restants</span>
                                    </div>
                                </div>
                                
                                <div class="request-categories" *ngIf="request.categories?.length">
                                    <div class="categories-tags">
                                        <span 
                                            class="category-tag" 
                                            *ngFor="let category of request.categories"
                                        >
                                            {{ category.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card-footer">
                                <div class="request-actions">
                                    <button class="btn btn-outline-primary" (click)="viewDetails(request)">
                                        <i class="icofont-eye"></i>
                                        Voir détails
                                    </button>
                                    
                                    <!-- <a class="btn btn-primary" [routerLink]="['/supplier/request', request.slug]">
                                        <i class="icofont-paper-plane"></i>
                                        Postuler
                                    </a> -->
                                </div>
                            </div>
                            
                            <div class="card-overlay">
                                <div class="overlay-content">
                                    <i class="flaticon-arrow-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Pagination -->
                    <div class="pagination-container" *ngIf="filteredRequests?.length > 0">
                        <ngb-pagination
                            [collectionSize]="collectionSize"
                            [(page)]="page"
                            [pageSize]="pageSize"
                            (pageChange)="refreshCompanies()"
                            class="custom-pagination"
                        >
                        </ngb-pagination>
                    </div>
                </ng-container>
                
                <!-- État Vide -->
                <div class="no-results-section" *ngIf="requests && requests.length === 0">
                    <div class="no-results-content text-center">
                        <div class="no-results-icon">
                            <i class="flaticon-search"></i>
                        </div>
                        <h3 class="no-results-title">Aucun appel d'offre trouvé</h3>
                        <p class="no-results-subtitle">
                            Aucun appel d'offre ne correspond à vos critères de recherche. 
                            Essayez de modifier vos filtres ou revenez plus tard.
                        </p>
                        <div class="no-results-actions">
                            <button class="btn btn-primary" (click)="clearFilters()">
                                <i class="flaticon-refresh"></i>
                                Réinitialiser les filtres
                            </button>
                            <button class="btn btn-outline-primary" routerLink="/">
                                <i class="flaticon-home"></i>
                                Retour à l'accueil
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="quick-actions-section">
    <div class="container">
        <div class="actions-grid">
            <div class="action-card">
                <div class="action-icon">
                    <i class="flaticon-bell"></i>
                </div>
                <h4 class="action-title">Notifications</h4>
                <p class="action-description">Recevez des alertes pour les nouveaux appels d'offres</p>
                <button class="btn btn-outline-primary">
                    <i class="flaticon-settings"></i>
                    Configurer
                </button>
            </div>
            
            <div class="action-card">
                <div class="action-icon">
                    <i class="flaticon-favorite"></i>
                </div>
                <h4 class="action-title">Favoris</h4>
                <p class="action-description">Sauvegardez vos appels d'offres préférés</p>
                <button class="btn btn-outline-primary">
                    <i class="flaticon-heart"></i>
                    Voir favoris
                </button>
            </div>
            
            <div class="action-card">
                <div class="action-icon">
                    <i class="flaticon-history"></i>
                </div>
                <h4 class="action-title">Historique</h4>
                <p class="action-description">Consultez vos candidatures précédentes</p>
                <button class="btn btn-outline-primary">
                    <i class="flaticon-list"></i>
                    Voir historique
                </button>
            </div>
        </div>
    </div>
</section>
